/**
 * Era Analytics — GA4 + Google Ads Conversion Tracking
 * 
 * GDPR: gtag consent is denied by default in index.html.
 * CookieConsentBanner grants analytics_storage on user consent.
 * Events are queued by gtag even before consent — sent once granted.
 */

const GA4_MEASUREMENT_ID = 'G-S8JFYNHM02';

/**
 * Track a custom event in GA4
 */
export const trackEvent = (eventName, params = {}) => {
  if (typeof window.gtag === 'function') {
    window.gtag('event', eventName, {
      ...params,
      send_to: GA4_MEASUREMENT_ID,
    });
  }
};

/**
 * Track user registration (free tier)
 */
export const trackRegistration = (method = 'email') => {
  trackEvent('sign_up', {
    method,
    event_category: 'engagement',
    event_label: 'registration',
  });
  // Google Ads conversion (will be activated when Ads Conversion ID is added)
  trackEvent('conversion', {
    event_category: 'registration',
    event_label: method,
  });
};

/**
 * Track free trial started
 */
export const trackTrialStarted = (tier = 'pro') => {
  trackEvent('begin_checkout', {
    event_category: 'subscription',
    event_label: 'trial_started',
    currency: 'USD',
    value: 0,
    items: [{ item_name: `Era ${tier} Trial`, item_category: 'subscription' }],
  });
  trackEvent('conversion', {
    event_category: 'trial',
    event_label: tier,
  });
};

/**
 * Track paid subscription completed
 */
export const trackSubscription = (tier, billingPeriod, value) => {
  trackEvent('purchase', {
    event_category: 'subscription',
    event_label: `${tier}_${billingPeriod}`,
    currency: 'USD',
    value: value || 0,
    transaction_id: `sub_${Date.now()}`,
    items: [{ item_name: `Era ${tier}`, item_category: 'subscription', price: value }],
  });
  trackEvent('conversion', {
    event_category: 'subscription',
    event_label: `${tier}_${billingPeriod}`,
    value: value || 0,
  });
};

/**
 * Track page view (called by router)
 */
export const trackPageView = (path, title) => {
  if (typeof window.gtag === 'function') {
    window.gtag('config', GA4_MEASUREMENT_ID, {
      page_path: path,
      page_title: title,
    });
  }
};

export default { trackEvent, trackRegistration, trackTrialStarted, trackSubscription, trackPageView };
